import pt from "./pt-BR";

const optionLanguage = [
  { key: "pt-BR", value: "pt-BR", file: pt },
  { key: "pt", value: "pt-BR", file: pt },
];

const chosenLanguage = optionLanguage.find((e) => e.key === navigator.language);

export const languageName = "pt-BR";
export const language = pt;
